<template>
  <div>
    <vx-card>
      <div class="flex h-12 mt-1 fit-height">
        <div class="w-full ml-2 fit-height">
          <form v-on:submit.prevent="salvar" id="formulario">

            <div class="float-right" v-if="!adicionandoLinkRapido">
              <vs-button color="success" icon-pack="feather" icon="icon-plus-square" type="flat" size="large" v-on:click="adicionar('linkRapido')"></vs-button>
            </div>

            <vs-divider position="center">Links rápidos</vs-divider>
            <vs-list>
              <draggable :list="rodape.primeira_sessao">
                <transition-group>
                  <vs-list-item class="list-item" v-for="(item, index) in rodape.primeira_sessao" :key="'primeira_sessao' + index" :title="item.titulo" :subtitle="item.link">
                    <vs-button radius color="danger" type="flat" icon-pack="feather" icon="icon-x-square" v-on:click="remover('linkRapido', index)" :key="'primeira_sessao' + index + 'remover'"></vs-button>
                  </vs-list-item>
                </transition-group>
              </draggable>
              <div class="flex h-12 mt-1 fit-height" v-if="adicionandoLinkRapido">
                <div class="w-1/3">
                  <vs-input class="w-full" icon-pack="feather" icon="icon-star" icon-no-border label-placeholder="Título" v-model="entrada.titulo" />
                </div>
                <div class="w-1/3 ml-2">
                  <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label-placeholder="Link" v-model="entrada.link" />
                </div>
                <div class="w-1/3 ml-2">
                  <vs-button color="danger" icon-pack="feather" icon="icon-x-square" style="float: left;" class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                  v-on:click="pararAdicao()"></vs-button>
                  <vs-button color="success" icon-pack="feather" icon="icon-check-square" style="float: left;" class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder" v-on:click="confirmarAdicao"></vs-button>
                </div>
              </div>
            </vs-list>

            <div class="float-right" v-if="!adicionandoOportunidades">
              <vs-button color="success" icon-pack="feather" icon="icon-plus-square" type="flat" size="large" v-on:click="adicionar('oportunidades')"></vs-button>
            </div>
            <vs-divider position="center">Oportunidades</vs-divider>
            <vs-list>
              <draggable :list="rodape.oportunidades">
                <transition-group>
                  <vs-list-item class="list-item" v-for="(item, index) in rodape.oportunidades" :key="'oportunidades' + index" :title="item.titulo" :subtitle="item.link">
                    <vs-button radius color="danger" type="flat" icon-pack="feather" icon="icon-x-square" v-on:click="remover('oportunidades', index)" :key="'oportunidades' + index + 'remover'"></vs-button>
                  </vs-list-item>
                </transition-group>

                <div class="flex h-12 mt-1 fit-height" v-if="adicionandoOportunidades">
                  <div class="w-1/3">
                    <vs-input class="w-full" icon-pack="feather" icon="icon-star" icon-no-border label-placeholder="Título" v-model="entrada.titulo" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label-placeholder="Link" v-model="entrada.link" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-button color="danger" icon-pack="feather" icon="icon-x-square" style="float: left;" class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                    v-on:click="pararAdicao()"></vs-button>
                    <vs-button color="success" icon-pack="feather" icon="icon-check-square" style="float: left;" class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder" v-on:click="confirmarAdicao"></vs-button>
                  </div>
                </div>

              </draggable>
            </vs-list>

            <div class="float-right" v-if="!adicionandoContato">
              <vs-button color="success" icon-pack="feather" icon="icon-plus-square" type="flat" size="large" v-on:click="adicionar('contato')"></vs-button>
            </div>
            <vs-divider position="center">Contato</vs-divider>
            <vs-list>
              <draggable :list="rodape.contato">
                <transition-group>
                  <vs-list-item class="list-item" v-for="(item, index) in rodape.contato" :key="'contato' + index" :title="item.titulo" :subtitle="item.link">
                    <vs-button radius color="danger" type="flat" icon-pack="feather" icon="icon-x-square" v-on:click="remover('contato', index)" :key="'contato' + index + 'remover'"></vs-button>
                  </vs-list-item>
                </transition-group>

                <div class="flex h-12 mt-1 fit-height" v-if="adicionandoContato">
                  <div class="w-1/3">
                    <vs-input class="w-full" icon-pack="feather" icon="icon-star" icon-no-border label-placeholder="Título" v-model="entrada.titulo" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label-placeholder="Link" v-model="entrada.link" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-button color="danger" icon-pack="feather" icon="icon-x-square" style="float: left;" class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                    v-on:click="pararAdicao()"></vs-button>
                    <vs-button color="success" icon-pack="feather" icon="icon-check-square" style="float: left;" class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder" v-on:click="confirmarAdicao"></vs-button>
                  </div>
                </div>

              </draggable>
            </vs-list>

            <div class="float-right" v-if="!adicionandoSobre">
              <vs-button color="success" icon-pack="feather" icon="icon-plus-square" type="flat" size="large" v-on:click="adicionar('sobre')"></vs-button>
            </div>
            <vs-divider position="center">Sobre</vs-divider>
            <vs-list>
              <draggable :list="rodape.sobre">
                <transition-group>
                  <vs-list-item class="list-item" v-for="(item, index) in rodape.sobre" :key="'sobre' + index" :title="item.titulo" :subtitle="item.link">
                    <vs-button radius color="danger" type="flat" icon-pack="feather" icon="icon-x-square" v-on:click="remover('sobre', index)" :key="'sobre' + index + 'remover'"></vs-button>
                  </vs-list-item>
                </transition-group>
                <div class="flex h-12 mt-1 fit-height" v-if="adicionandoSobre">
                  <div class="w-1/3">
                    <vs-input class="w-full" icon-pack="feather" icon="icon-star" icon-no-border label-placeholder="Título" v-model="entrada.titulo" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border label-placeholder="Link" v-model="entrada.link" />
                  </div>
                  <div class="w-1/3 ml-2">
                    <vs-button color="danger" icon-pack="feather" icon="icon-x-square" style="float: left;" class="w-1/3 mr-auto ml-10 vs-con-input-label is-label-placeholder"
                    v-on:click="pararAdicao()"></vs-button>
                    <vs-button color="success" icon-pack="feather" icon="icon-check-square" style="float: left;" class="ml-3 w-1/3 mr-auto vs-con-input-label is-label-placeholder" v-on:click="confirmarAdicao"></vs-button>
                  </div>
                </div>
              </draggable>
            </vs-list>

            <vs-divider position="center">Redes Sociais</vs-divider>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Facebook</label>
                  <div class="vs-con-input">
                    <input
                      v-model="rodape.facebook"
                      type="url"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-facebook null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Instagram</label>
                  <div class="vs-con-input">
                    <input
                      v-model="rodape.instagram"
                      type="url"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-instagram null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">YouTube</label>
                  <div class="vs-con-input">
                    <input
                      v-model="rodape.youtube"
                      type="url"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-youtube null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Twitter</label>
                  <div class="vs-con-input">
                    <input
                      v-model="rodape.twitter"
                      type="url"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                    />
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-twitter null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div>
          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  data() {
    return {
      adicionandoLinkRapido: false,
      adicionandoOportunidades: false,
      adicionandoContato: false,
      adicionandoSobre: false,
      rodape: {
        primeira_sessao: [],
        oportunidades: [],
        contato: [],
        sobre: [],
        facebook: '',
        instagram: '',
        youtube: '',
        twitter: ''
      },
      entrada: {
        titulo: '',
        link: '',
        sessao: ''
      }
    }
  },
  methods: {
    remover: function(sessao, index) {
      if (sessao == 'linkRapido') {
        this.rodape.primeira_sessao.splice(index, 1);
      } else if (sessao == 'oportunidades') {
        this.rodape.oportunidades.splice(index, 1);
      } else if (sessao == 'contato') {
        this.rodape.contato.splice(index, 1);
      } else if (sessao == 'sobre') {
        this.rodape.sobre.splice(index, 1);
      }
    },
    confirmarAdicao: function() {
      if (this.entrada.sessao == 'linkRapido') {
        this.rodape.primeira_sessao.push(this.entrada);
      } else if (this.entrada.sessao == 'oportunidades') {
        this.rodape.oportunidades.push(this.entrada);
      } else if (this.entrada.sessao == 'contato') {
        this.rodape.contato.push(this.entrada);
      } else if (this.entrada.sessao == 'sobre') {
        this.rodape.sobre.push(this.entrada);
      }
      this.pararAdicao()
    },
    adicionar: function(sessao) {
      this.pararAdicao(sessao);

      this.entrada.sessao = sessao;
      if (sessao == 'linkRapido') {
        this.adicionandoLinkRapido = true;
      } else if (sessao == 'oportunidades') {
        this.adicionandoOportunidades = true;
      } else if (sessao == 'contato') {
        this.adicionandoContato = true;
      } else if (sessao == 'sobre') {
        this.adicionandoSobre = true;
      }
    },
    pararAdicao: function(sessao = '') {
      if (this.adicionandoLinkRapido && sessao != 'linkRapido') {
        this.adicionandoLinkRapido = false;
      } else if (this.adicionandoOportunidades && sessao != 'oportunidades') {
        this.adicionandoOportunidades = false;
      } else if (this.adicionandoContato && sessao != 'linkRapido2') {
        this.adicionandoContato = false;
      } else if (this.adicionandoSobre && sessao != 'linkRapido2') {
        this.adicionandoSobre = false;
      }
      this.entrada = {
        titulo: '',
        link: '',
        sessao: ''
      }
    },
    salvar: function() {
      fetch(this.$API_URL + "/footer/", {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.rodape)
      })
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }
      })
    },
    getFooter: function() {
      fetch(this.$API_URL + "/footer/dados", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.data.length > 0)
          this.rodape = json.data[0]
      });
    }
  },
  mounted() {
    this.getFooter();
  }
}
</script>

<style>
  .fit-height {
    height: fit-content !important;
  }

  .list-item {
    transition: all 1s
  }

  .con-vs-avatar {
    width: 24px !important;
    height: 24px !important;
  }

  .vuesax-app-is-ltr .vs-list--slot, .vs-list--slot {
    margin-left: unset !important;
    margin-top: -15px !important;
    margin-left: -5px !important;
  }

  .vs-button.large .vs-button--icon {
    font-size: 22px;
    margin-top: 10px;
  }
</style>
